/* eslint-disable linebreak-style */
/* eslint-disable no-loop-func */
// prompt scene to show that the payment is being processed after the validation is passed
export default function paymentProcessingScene() {
    if (document.getElementById('payment-prompt') && document.getElementById('payment-processing-scene-wrap') && document.getElementById('frame')) {
        const PROMPT_WRAP = document.getElementById('payment-processing-scene-wrap');

        // darken background
        const BACKGROUND = document.createElement('div');
        document.getElementById('payment-prompt').insertBefore(BACKGROUND, PROMPT_WRAP);
        BACKGROUND.classList.add('apply-mask');

        PROMPT_WRAP.style.display = 'flex';

        const PROGRESSBAR = document.getElementById('frame');
        const TIMER = 1000; // 1s
        let width = 10;// innitially width is filled 10%
        // Percentages as per the design.
        // stops at 95% as this is hardcoded from front-end and might take more time to land on the Thank you page
        // after all the validations are passed from backend
        const PROGRESSBAR_STATE = [10, 40, 60, 80, 95];

        for (let i = 0; i <= 4; i += 1) {
            setTimeout(() => {
                width = PROGRESSBAR_STATE[i];
                PROGRESSBAR.style.width = `${width}%`;
            }, i * TIMER);
        }
    }
}




// WEBPACK FOOTER //
// ./src/js/utils/payment-processing-scene.js